<template>
  <div class="card">
    <div class="header-with-line">
      <h2>{{ temelAnalizDegerleri.donem }}</h2>
    </div>
    <h3>Temel Analiz</h3>
    <div class="finance-cards" v-if="temelAnalizDegerleri">
      <div class="finance-card">
        <div class="card-title">F/K</div>
        <div class="card-value">{{ temelAnalizDegerleri.FK }}</div>
      </div>
      <div class="finance-card">
        <div class="card-title">PD/DD</div>
        <div class="card-value">{{ temelAnalizDegerleri.PDDD }}</div>
      </div>
      <div class="finance-card">
        <div class="card-title">Hedef Fiyat</div>
        <div class="card-value">
          {{ formatPrice(temelAnalizDegerleri.Hedef_Fiyat) }} ₺
        </div>
      </div>
      <div
        class="finance-card potansiyel-card"
        :class="{
          'potansiyel-positive': temelAnalizDegerleri.Potansiyel > 0,
          'potansiyel-negative': temelAnalizDegerleri.Potansiyel < 0,
          'potansiyel-neutral': temelAnalizDegerleri.Potansiyel === 0,
        }"
      >
        <div class="card-title">Potansiyel</div>
        <div
          class="card-value"
          :class="{
            positive: temelAnalizDegerleri.Potansiyel > 0,
            negative: temelAnalizDegerleri.Potansiyel < 0,
          }"
        >
          {{ formatPotential(temelAnalizDegerleri.Potansiyel) }}
        </div>
      </div>
    </div>

    <div class="finance-table-container" v-if="temelAnalizDegerleri">
      <!-- Finansal Veriler Tablosu -->
      <table class="finance-table">
        <thead>
          <tr>
            <th>Finansal Veri</th>
            <th>Değer</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Özkaynaklar</td>
            <td>
              {{ formatCurrency(temelAnalizDegerleri.ozkaynaklar) }}
            </td>
          </tr>
          <tr>
            <td>Ödenmiş Sermaye</td>
            <td>
              {{ formatCurrency(temelAnalizDegerleri.odenmisSermaye) }}
            </td>
          </tr>
          <tr>
            <td>Satış Gelirleri</td>
            <td>
              {{ formatCurrency(temelAnalizDegerleri.satisGelirleri) }}
            </td>
          </tr>
          <tr>
            <td>Brüt Kar</td>
            <td>
              {{ formatCurrency(temelAnalizDegerleri.brutKar) }}
            </td>
          </tr>
          <tr>
            <td>Net Dönem Karı</td>
            <td>
              {{ formatCurrency(temelAnalizDegerleri.netDonemKari) }}
            </td>
          </tr>
          <tr>
            <td>Faaliyet Karı</td>
            <td>
              {{ formatCurrency(temelAnalizDegerleri.faaliyetKari) }}
            </td>
          </tr>
        </tbody>
      </table>

      <!-- Piyasa Verileri Tablosu -->
      <table class="finance-table">
        <thead>
          <tr>
            <th>Piyasa Verisi</th>
            <th>Değer</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Güncel Fiyat</td>
            <td>{{ formatPrice(temelAnalizDegerleri.hisseFiyati) }} ₺</td>
          </tr>
          <tr>
            <td>HBK Değeri</td>
            <td>{{ formatPrice(temelAnalizDegerleri.HBK_Ederi) }} ₺</td>
          </tr>
          <tr>
            <td>EFK Değeri</td>
            <td>{{ formatPrice(temelAnalizDegerleri.EFK_Ederi) }} ₺</td>
          </tr>
          <tr>
            <td>Kar Değeri</td>
            <td>{{ formatPrice(temelAnalizDegerleri.KAR_Ederi) }} ₺</td>
          </tr>
          <tr>
            <td>Hedef Fiyat</td>
            <td>{{ formatPrice(temelAnalizDegerleri.Hedef_Fiyat) }} ₺</td>
          </tr>
          <tr>
            <td>Potansiyel</td>
            <td
              :class="{
                positive: temelAnalizDegerleri.Potansiyel > 0,
                negative: temelAnalizDegerleri.Potansiyel < 0,
              }"
            >
              {{ temelAnalizDegerleri.Potansiyel > 0 ? "+" : ""
              }}{{ temelAnalizDegerleri.Potansiyel }} %
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import {
  formatCurrency,
  formatPrice,
  formatPotential,
} from "@/utils/formatHelpers";

export default {
  props: {
    temelAnalizDegerleri: {
      type: Object,
      required: true,
    },
  },
  methods: {
    formatCurrency(value) {
      return formatCurrency(value);
    },
    formatPrice(value) {
      return formatPrice(value);
    },
    formatPotential(value) {
      return formatPotential(value);
    },
  },
};
</script>

<style scoped>
:root {
  --success-color: #10b981;
  --danger-color: #ef4444;
  --card-bg: #1e293b;
  --card-dark: #0f172a;
  --hover-bg: #334155;
}

.card {
  background-color: var(--card-bg);
  border-radius: 12px;
  padding: 1.5rem;
  margin-bottom: 1.5rem;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),
    0 2px 4px -1px rgba(0, 0, 0, 0.06);
}

.card h3 {
  font-size: 18px;
  font-weight: 600;
  color: var(--text-primary);
  margin-bottom: 1rem;
}

.header-with-line {
  border-bottom: 1px solid rgba(229, 231, 235, 0.5); /* HisseHeader'daki çizgiye benzer stil */
  padding-bottom: 1rem; /* Çizgi ile içerik arasına boşluk ekle */
  margin-bottom: 1rem; /* Çizgi ile sonraki içerik arasına boşluk ekle */
}

h2 {
  color: var(--text-secondary);
  margin-bottom: 0;
  font-size: 1.5rem;
  font-weight: 600;
}

.finance-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1rem;
}

.finance-card {
  padding: 1.5rem;
  background-color: var(--card-dark);
  border-radius: 8px;
  border: 1px solid var(--border-color);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  transition: all 0.2s ease;
}

.finance-card:hover {
  background-color: var(--hover-bg);
}

.card-title {
  font-size: 14px;
  color: var(--text-muted);
  text-align: center;
}

.card-value {
  font-size: 18px;
  font-weight: 600;
  color: var(--text-primary);
}

.potansiyel-card {
  border-width: 2px;
  transition: all 0.3s ease;
}

.potansiyel-positive {
  border-color: var(--success-color);
  box-shadow: 0 0 8px rgba(16, 185, 129, 0.8);
}

.potansiyel-negative {
  border-color: var(--danger-color);
  box-shadow: 0 0 8px rgba(239, 68, 68, 0.8);
}

.potansiyel-neutral {
  border-color: var(--text-muted);
}

.potansiyel-card:hover.potansiyel-positive {
  background-color: rgba(16, 185, 129, 0.1);
}

.potansiyel-card:hover.potansiyel-negative {
  background-color: rgba(239, 68, 68, 0.1);
}

.positive {
  color: var(--success-color);
}

.negative {
  color: var(--danger-color);
}

.finance-table-container {
  overflow-x: auto;
  margin-top: 1.5rem;
  display: flex;
  gap: 1.5rem;
}

.finance-table {
  width: 100%;
  border-collapse: collapse;
  background-color: var(--card-dark);
  border-radius: 8px;
  border: 1px solid var(--border-color);
  flex: 1;
  margin-bottom: 1rem;
}

.finance-table th,
.finance-table td {
  padding: 1rem;
  text-align: left;
  border-bottom: 1px solid var(--border-color);
}

.finance-table th {
  font-weight: 600;
  color: var(--text-primary);
  background-color: var(--card-dark);
}

.finance-table td {
  color: var(--text-secondary);
}

.finance-table tr th:nth-child(2),
.finance-table tr td:nth-child(2) {
  text-align: right;
}

.finance-table tr:last-child td {
  border-bottom: none;
}

.finance-table tbody tr:nth-child(odd) {
  background-color: rgba(255, 255, 255, 0.02);
}

.finance-table tbody tr:nth-child(even) {
  background-color: rgba(255, 255, 255, 0.05);
}

.finance-table tbody tr:hover {
  background-color: rgba(55, 175, 255, 0.1);
}

@media (max-width: 992px) {
  .finance-cards {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .card {
    padding: 1rem;
    margin-bottom: 1rem;
  }

  .card h3 {
    font-size: 16px;
    margin-bottom: 0.75rem;
  }

  .finance-cards {
    grid-template-columns: repeat(2, 1fr);
    gap: 0.75rem;
  }

  .finance-card {
    padding: 1rem;
  }

  .card-title {
    font-size: 12px;
  }

  .card-value {
    font-size: 16px;
  }

  .finance-table-container {
    flex-direction: column;
    gap: 1rem;
    margin-top: 1rem;
  }

  .finance-table {
    width: 100%;
    margin-bottom: 0.75rem;
  }

  .finance-table th,
  .finance-table td {
    padding: 0.75rem;
    font-size: 14px;
  }
}

@media (max-width: 480px) {
  .finance-cards {
    grid-template-columns: repeat(2, 1fr);
    gap: 0.5rem;
  }

  .finance-card {
    padding: 0.75rem;
  }

  .card-title {
    font-size: 11px;
  }

  .card-value {
    font-size: 14px;
  }

  .finance-table th,
  .finance-table td {
    padding: 0.5rem;
    font-size: 12px;
  }

  .potansiyel-positive {
    box-shadow: 0 0 5px rgba(16, 185, 129, 0.6);
  }

  .potansiyel-negative {
    box-shadow: 0 0 5px rgba(239, 68, 68, 0.6);
  }
}

@media (max-width: 360px) {
  .card {
    padding: 0.75rem;
  }

  .finance-cards {
    grid-template-columns: 1fr;
  }

  .finance-card {
    padding: 0.75rem 0.5rem;
  }

  .finance-table-container {
    margin-top: 0.75rem;
  }

  .finance-table th,
  .finance-table td {
    padding: 0.5rem 0.3rem;
    font-size: 11px;
  }
}
</style>
